import { dataFetch } from '@lib/ggj-utils'

export default {

  // 模板
	manageHome(params) {
    return dataFetch('/wholesale/api/personal/home', params, {
      method: 'get',
    })
  },
	manageHomeIncome(params) {
		return dataFetch('/wholesale/api/personal/home/income', params, {
			method: 'get',
		})
	},
	showCount(params) {
		return dataFetch('/orderbuyer/api/order/show/count', params, {
			method: 'get',
		})
	},
	getBannerImg(params) {
		return dataFetch('/ruban/api/res/data', params,{ method: 'get' })
	},

}
